import {useCallback, useMemo, useState} from 'react'
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom'
import {useUserInfoContext} from '@/store/userInfo'
import style from '../style.module.less'

import djIcon from './images/jlgj.png'
import zlgjIcon from './images/zlgj.png'
import jlgjIcon from './images/hjgj.png'
import clgjIcon from './images/clgj.png'
import sdgjIcon from './images/sdgj.png'
import fjgjIcon from './images/fjgj.png'


const iconMap = {
    '整机': zlgjIcon,
    '电机': djIcon,
    '配件': clgjIcon,
    '附件': fjgjIcon,
    '手动工具': sdgjIcon,
    '机电产品': jlgjIcon
}

const Menu = () => {
    const [secondOptions, setSecondOptions] = useState([])
    const [thirdOptions, setThirdOptions] = useState([])
    const [activeSecond, setActiveSecond] = useState('')
    const navigator = useNavigate()
    const location = useLocation()
    const [searchParams] = useSearchParams()
    const {inventoryClass} = useUserInfoContext()

    const categoryOptions = useMemo(() => {
        return inventoryClass.map(row => ({
            ...row,
            icon: iconMap[row.classname],
            classname: row.classname === '配件' ? '部件目录区' : row.classname
        }))
    }, [inventoryClass])

    // 激活一级菜单
    const handleFitsrMenu = useCallback((row) => {
        if (row.classname === '部件目录区') {
            setSecondOptions([])
            return
        }
        setSecondOptions(row.child || [])
        // 如果当前查询的在里面，则激活查询的
        const lbbm = searchParams.get('lbbm')
        if (location.pathname === '/product' && lbbm) {
            const activeSecondRow = row.child.find(c => c.classcode === lbbm || (c.child || []).some(t => t.classcode === lbbm))
            if (activeSecondRow) {
                setActiveSecond(activeSecondRow.classcode)
                setThirdOptions(activeSecondRow.child || [])
                return
            }
        }
        setActiveSecond(row.child[0] && row.child[0].classcode || '')
        setThirdOptions(row.child[0] && row.child[0].child || [])
    }, [location.pathname, searchParams])

    // 激活二级菜单
    const handleSecondMenu = useCallback((row) => {
        setThirdOptions(row.child || [])
        setActiveSecond(row.classcode)
    }, [])

    // 选择三级菜单查询
    const handleQuery = useCallback((row) => {
        if (row.classname === '部件目录区') {
            navigator('/bjmlq')
            return
        }
        setThirdOptions(row.child || [])
        setActiveSecond(row.classcode)
        navigator('/product?lbbm=' + row.classcode, {
            replace: true
        })
    }, [navigator])

    return (
        <div className={`bg-white ${style['banner-menu']}`}>
            {
                categoryOptions.map(row => (
                    <div onClick={() => handleQuery(row)} className={`flex align-center ${style['banner-menu-item']}`}
                         key={row.classcode} onMouseEnter={() => handleFitsrMenu(row)}>
                        <img src={row.icon} alt=""/>
                        <span>{row.classname}</span>
                    </div>
                ))
            }
            {
                secondOptions.length > 0 && (
                    <div className={`${style['banner-menu-container']}`}>
                        <div className='flex flex-column h-full'>
                            <div className={style['banner-menu-head']}>
                                {
                                    secondOptions.map(second => <span onClick={() => handleQuery(second)}
                                        // onMouseEnter={() => handleSecondMenu(second)}
                                                                      className={activeSecond === second.classcode && 'active'}
                                                                      key={second.classcode}>{second.classname}</span>)
                                }
                            </div>
                            <div
                                className='flex-1 h-0 overflow-auto-y flex flex-wrap align-content-baseline plr-8 ptb-4 font-14'>
                                {
                                    thirdOptions.map((third) => (
                                        <div className={`flex align-center ${style['banner-menu-child-item']}`}
                                             key={third.classcode} onClick={() => handleQuery(third)}>
                                            {/* <img src={row.pic} alt="" /> */}
                                            <span>{third.classname}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default Menu
